import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, RouterModule],
})
export class SectionHeaderComponent {
  @Input() title: string;
  @Input() isBackBtnShown = false;
  @Input() preserveQueryParam = false;
  @Input() backRoute = ['../'];
}
